<div
    appBsModal
    #viewRecoveryCodesModal="bs-modal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    [config]="{ backdrop: 'static' }"
>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    <span>{{ 'ViewRecoveryCodes' | localize }}</span>
                </h5>
                <button type="button" class="btn-close" [attr.aria-label]="l('Close')" (click)="close()"></button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="card">
                        <div class="card-body pt-0">
                            <recoveryCodesComponent #recoveryCodesComponent></recoveryCodesComponent>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<verifyCodeModal #verifyCodeModal (modalSave)="showRecoveryCodes(verifyCodeModal.verifyCodeInput)"></verifyCodeModal>